import type { WixCodeApiFactoryArgs } from '@wix/thunderbolt-symbols'
import type { RealtimeWixCodeSdkWixCodeApi } from '..'
import { namespace } from '..'
import { realtime } from './realtime'
import { Environment } from './environment'
import { isExperimentOpen } from '@wix/thunderbolt-experiments'

type RealtimeNamespace = { [namespace]: RealtimeWixCodeSdkWixCodeApi }

export function RealtimeSdkFactory({
	wixCodeNamespacesRegistry,
	onPageWillUnmount,
	platformUtils,
	platformEnvData,
}: WixCodeApiFactoryArgs): RealtimeNamespace {
	const environment = new Environment(wixCodeNamespacesRegistry, platformUtils, platformEnvData)
	const duplexerSocketsServiceUrl = 'duplexer.wix.com'
	const isAddRevisionToChannelNameInRealtimeEnabled = Boolean(
		isExperimentOpen(platformEnvData.site.experiments, 'specs.core-services.AddRevisionToChannelNameInRealtime')
	)
	return {
		[namespace]: realtime(
			duplexerSocketsServiceUrl,
			environment,
			onPageWillUnmount,
			isAddRevisionToChannelNameInRealtimeEnabled
		),
	}
}
